module.exports = __webpack_public_path__ + "img/capture.71c9ef6a.svg";